const typography: ThemeTypography = {
  fontSize: 14,
};

export default typography;
